import { Component, OnInit, inject } from '@angular/core';
import { GameFilterService } from '../../../../services/games/game-filter.service';
import { NgClass } from '@angular/common';
import { GameSearchService } from '../../../../services/games/game-search.service';

@Component({
    selector: 'app-games-filter',
    templateUrl: './games-filter.component.html',
    styleUrls: ['./games-filter.component.scss'],
    imports: [NgClass]
})
export class GamesFilterComponent implements OnInit {
  gamesFilter = inject(GameFilterService);
  gamesSearch = inject(GameSearchService);


  ngOnInit(): void {}
}
